var map = {
	"./external-logo-google.png": 4214,
	"./icon-chatgpt.svg": 4025,
	"./icon-helping-friendly.png": 4270,
	"./icon-inphinite.png": 8623,
	"./icon-kodi.png": 2088,
	"./icon-live-music-archive.png": 8234,
	"./icon-phishstats.png": 7970,
	"./icon-relisten.png": 9645,
	"./icon-splendor.png": 8054,
	"./icon-volumio.png": 3586,
	"./logo-full.png": 1754,
	"./logo-square-180.png": 1686,
	"./logo-square-192.png": 7651,
	"./logo-square-512.png": 3575,
	"./logo-square-512.svg": 6472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;